<template>
    <div class="ma-auto">
        <template v-if="account">
            <SetPassword v-if="!account.PasswordSet" />
            <AccountActivation v-else-if="!account.Activated" :email="account.Email" />
            <Workspaces v-else redirect />
        </template>
    </div>
</template>

<script>
import SetPassword from '../auth/SetPassword';
import AccountActivation from '../auth/AccountActivation';
import Workspaces from './Workspaces';

export default {
    components: {SetPassword, AccountActivation, Workspaces},

    data() {
        return {
            account: null,
        };
    },

    mounted() {
        this.getAccount();
    },

    methods: {
        getAccount() {
            this.$api.account((data) => {
                this.account = data;
            });
        },
    },
};
</script>

<style scoped>

</style>
